import formatDuration from '@/utils/formatting/formatDuration'

import styles from './TrackDurationAndTempo.module.css'
import { TrackDurationAndTempoProps } from './TrackDurationAndTempo.types'

const TrackDurationAndTempo = ({
	track,
}: TrackDurationAndTempoProps): JSX.Element => {
	const { duration, startBpm } = track
	return (
		<div className={styles.durationAndTempo}>
			{Number.isFinite(duration) && (
				<span className={styles.detail}>{formatDuration(duration)}</span>
			)}
			{Number.isFinite(startBpm) && (
				<span className={styles.detail}>{startBpm} BPM</span>
			)}
		</div>
	)
}

export default TrackDurationAndTempo
